@if (showRecorder) {
  <screen-recorder></screen-recorder>
}
<div class="system-view-app form-field-density-4"  [ngClass]="{'theme-alternate': isDarkTheme | async}">
    <mat-toolbar class="mat-elevation-z3">
      <div class="menu-class">
          <span>
              <img *ngIf="!(isDarkTheme|async)" src="assets/image/Logotipo_TemAPI_SemFundo-01.png" class="logimage" />
              <img *ngIf="isDarkTheme|async" src="assets/image/Logotipo_TemAPI_SemFundo-02.png" class="logimage" />
          </span>
          
            @if (hasActiveRoute && this.UserAuthenticationServices.user.iddashboard!=null && this.UserAuthenticationServices.user.iddashboard>0) {
              <div class="vl"></div>
              <nz-icon class="trigger-icon" nzTheme="twotone" nzType="dashboard" (click)="backToDashboard()" [nz-tooltip]="('system.voltaraoashboard'|translateTA)"></nz-icon>
            }
            @if (!hasActiveRoute && this.UserAuthenticationServices.user.iddashboard!=null && this.UserAuthenticationServices.user.iddashboard>0){
              <div class="vl"></div>
              <nz-icon class="trigger-icon" style-color="blue" nzType="desktop" (click)="backToRoute()" [nz-tooltip]="('system.voltartabs'|translateTA)"></nz-icon>
            }
            
          <div class="flex-spacer"></div>
          @if(canViewRec){
            <div class="recorder-toggle" >
              <span>{{'system.ativargravador'|translateTA}}</span>
              <nz-switch 
                [nzSize]="'small'"
                [(ngModel)]="showRecorder" >
              </nz-switch>
            </div>
            <div class="vl"></div>   
          }
         <div class="search">
            <form class="search-form" [formGroup]="formLink">
                <div>
                    <nz-input-wrapper class="search-full-width">
                        <input 
                            nz-input 
                            formControlName="linkName" 
                            [placeholder]="'controlk'|translateTA" 
                            #inputResourceFinder
                            aria-label="Busca de Recurso"
                            [nzAutocomplete]="auto">
                             <nz-icon nzInputSuffix nzType="search" />
                    </nz-input-wrapper>
                    <nz-autocomplete 
                        #auto="nzAutocomplete"
                        (selectionChange)="onSelectItem($event)">
                         @for (route of linksRoute| async; track trackByRoute) {
                          <nz-auto-option 
                              [nzValue]="route.IDMENU">
                              <div class="search-option">
                                  <div class="search-option-description">{{'menu.'+route.IDMENU|translateTA}}</div>
                                  <div class="flex-spacer"></div>
                                  <generic-icon class="routeIconSvg" *ngIf="route.svgIconName != null" [iconName]="route.svgIconName != null ? route.svgIconName : route.iconName" [type]="route.svgIconName != null?'custom':'google'"></generic-icon>
                                  <generic-icon class="routeIcon" *ngIf="route.svgIconName == null"   [iconName]="route.svgIconName != null ? route.svgIconName : route.iconName" [type]="route.svgIconName != null?'custom':'google'"></generic-icon>
                              </div>
                          </nz-auto-option>
                        }
                    </nz-autocomplete>
                </div>
            </form>
          </div>
          <div class="vl"></div>
          <span class="mktpico">
              <!--mat-animated-icon start="notifications" shake="true" [doShake]="shake"  (click)="showNotif()" 
              badgeSize="small" [badgeLength]="badgeSize" [badgeHidden]="badgeHidden">
              </mat-animated-icon-->
              <!-- <nz-icon nzType="bell" nzTheme="twotone" class="trigger-icon" /> -->
              <div class="icon-notification-container">
                <notifications-card  #notif ></notifications-card>
              </div>
          </span>
          <!--notifications-card *ngIf="showNot" #notif (outClickEvent)="notBlur($event)" [notifications]="notifications"></notifications-card-->
          
          <div class="vl"></div>
          <div nz-dropdown 
               [nzDropdownMenu]="languageMenu" 
               nzPlacement="bottomRight">
            <button nz-button nzType="text" nzSize="large">
              <nz-icon nzType="global"></nz-icon>
            </button>
          </div>
          <nz-dropdown-menu #languageMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="changeLanguage('en-US')">
                <nz-icon nzType="custom:us_1x1" nzTheme="outline"></nz-icon>
                <span class="name-country">English-US</span>
              </li>
              <li nz-menu-item (click)="changeLanguage('pt-BR')">
                <nz-icon nzType="custom:br_1x1" nzTheme="outline"></nz-icon>
                <span class="name-country">Português-BR</span>
              </li>
            </ul>
          </nz-dropdown-menu>
          <div class="vl"></div>
           <div nz-dropdown 
               [nzDropdownMenu]="menu" 
               nzPlacement="bottomRight">
            <button nz-button nzType="text" nzSize="large">
              <nz-icon nzType="custom:temapi"></nz-icon>
            </button>
          </div>
           <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <span class="username">{{userName}}</span>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="openConf()" class="menu-item-class">
                <nz-icon nzType="user" nzTheme="outline"></nz-icon>
                <span class="name-country">{{'profile'|translateTA}}</span>
              </li>
              <li nz-menu-item (click)="logout()" class="menu-item-class">
                <nz-icon nzType="logout" nzTheme="outline"></nz-icon>
                <span class="name-country">{{'logout'|translateTA}}</span>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
    </mat-toolbar>
    
    <mat-sidenav-container class="m-sidenav-container" (mouseout)="toggle('close')">
     <mat-sidenav class.mat-elevation-z8 fixedInViewport="true" #sidenav mode="side" opened (mouseover)="toggle('open')" 
      [ngClass]="{'m-sidenav': true, 'm-sidenav-small': navService.sidenavSmall && !locked}" > 
        <mat-animated-icon [hidden]="navService.sidenavSmall && !locked" (click)="locked=!locked;saveOption(locked)" class="locker-icon" [start]="!locked?'keep':'keep_off'" [end]="locked?'keep_off':'keep'"  size="14" [colorEnd]="locked? '#ef3140':'primary'" [colorStart]="!locked?'primary':'#ef3140'" [animate]="true" [pointer]="true"></mat-animated-icon>
        <mat-nav-list  [ngStyle]="!navService.sidenavSmall? { 'border-top-style': 'solid','border-top-width': '0.5px','margin-top': '10px','border-top-color': 'rgba(0, 0, 0, 0.20)'}: null" >
          <app-menu-list-item *ngFor="let item of navItems" [item]="item"></app-menu-list-item>
        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content [ngClass]="{'m-main': true, 'm-main-large': !navService.sidenavSmall}" >
            
            <!-- Tabs Container - Gerencia Dashboard e Rotas -->
            <mat-tab-group class="main-tab-group" 
                          [(selectedIndex)]="selectedTabIndex">
              
              <!-- Aba Hidden: Dashboard -->
              <mat-tab label="Dashboard" class="hidden-tab" *ngIf="UserAuthenticationServices.user.iddashboard!=null && UserAuthenticationServices.user.iddashboard>0">
                <ng-template mat-tab-label></ng-template>
                <main-dashboard class="dashboard-bg" 
                               [iddashboard]="UserAuthenticationServices.user.iddashboard" 
                               *ngIf="UserAuthenticationServices.user.iddashboard!=null && UserAuthenticationServices.user.iddashboard>0">
                </main-dashboard>
              </mat-tab>

              <!-- Aba: Conteúdo de Rotas -->
              <mat-tab label="Routes" class="hidden-tab">
                <ng-template mat-tab-label></ng-template>
                
                <!-- Abas de usuário -->
                <div class="tab-container" *ngIf="useTab">
                  <nav mat-tab-nav-bar  [tabPanel]="tabPanel" #tabgroup  *ngIf="tabService.tabs.length > 0">
                    <a mat-tab-link  *ngFor="let tab of tabService.tabs; let i = index;" [routerLink]="tab?.url || 'home'"
                    routerLinkActive skipLocationChange #hrla="routerLinkActive" 
                    [active]="hrla.isActive">
                      <div class="tab">
                        <span class="tab-title">{{tab?.name || 'Sem Título'|translateTA}}</span>
                        <mat-icon class="fechar" (click)="closeTab(i,$event)">close</mat-icon>
                      </div>
                    </a>
                  </nav>
                  <mat-tab-nav-panel #tabPanel>
                  <div class="router">
                    <router-outlet></router-outlet>
                  </div>
                  </mat-tab-nav-panel>
                </div>

                <!-- Router sem abas -->
                <router-outlet *ngIf="!useTab" class="router-outlet-main"></router-outlet>
              </mat-tab>

            </mat-tab-group>

        </mat-sidenav-content>
    </mat-sidenav-container>
    
    <mat-toolbar class.mat-elevation-z8 id="footer">
        <div class="version-info" mat-elevation-z6>
            Versão Angular: {{version.major}} - Aplicação: {{ versionApp }}
        </div>
    </mat-toolbar>

</div>